// removed by extract-text-webpack-plugin
module.exports = {"Content":"Layout__Content__2fWdX"};


//////////////////
// WEBPACK FOOTER
// ./src/containers/Layout/Layout.css
// module id = 288
// module chunks = 3